<template>
    <nav class="bottom-nav" aria-label="Main navigation">
        <div class="bottom-nav-item" :class="{ 'bottom-nav-item--active': isHome }">
            <router-link to="/" class="bottom-nav-link" aria-label="Go to Home" :aria-current="isHome ? 'page' : null"
                @click.native="closeSidebar">
                <span class="bottom-nav-icon-wrap" aria-hidden="true">
                    <img src="@/assets/img/icons/home.svg" alt="" class="bottom-nav-icon" />
                </span>
                <span class="bottom-nav-label">Home</span>
            </router-link>
        </div>
        <div class="bottom-nav-item" :class="{ 'bottom-nav-item--active': isCasino }">
            <router-link to="/casino" class="bottom-nav-link" aria-label="Go to Casino"
                :aria-current="isCasino ? 'page' : null" @click.native="closeSidebar">
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 14 14"
                    class="bottom-nav-icon-svg" style="width: 20px; height: 20px;">
                    <g clip-path="url(#icon-duel-cards-1_svg__a)">
                        <path fill-rule="evenodd"
                            d="M7.196.378A.48.48 0 0 1 7.56.33l6.085 1.629a.48.48 0 0 1 .34.588l-2.335 8.707a.48.48 0 0 1-.587.34L4.98 9.964a.48.48 0 0 1-.34-.587L6.973.669a.48.48 0 0 1 .223-.29M5.03 3.098 3.433 9.053l-.001-.001a1.73 1.73 0 0 0 1.223 2.12l4.39 1.175-.023.007-6.084 1.63a.48.48 0 0 1-.587-.34L.016 4.937a.48.48 0 0 1 .34-.588zm4.758 1.428c-.282-.458-.606-.713-.934-.808-.346-.101-.682-.02-.953.166-.534.365-.834 1.155-.46 1.804l1.042 1.785a.7.7 0 0 0 .961.258l1.795-1.026c.647-.373.78-1.207.5-1.79a1.12 1.12 0 0 0-.74-.621c-.332-.082-.74-.023-1.211.232"
                            clip-rule="evenodd"></path>
                    </g>
                    <defs>
                        <clipPath id="icon-duel-cards-1_svg__a">
                            <path d="M0 0h14v14H0z"></path>
                        </clipPath>
                    </defs>
                </svg>
                <span class="bottom-nav-label">Casino</span>
            </router-link>
        </div>
        <div class="bottom-nav-item" :class="{ 'bottom-nav-item--active': isSports }">
            <router-link to="/sports" class="bottom-nav-link" aria-label="Go to Sports"
                :aria-current="isSports ? 'page' : null" @click.native="closeSidebar">
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 14 14"
                    class="bottom-nav-icon-svg" style="width: 20px; height: 20px;">
                    <path fill-rule="evenodd"
                        d="M3.099 1.998c0-.057.028-.114.074-.15v-.003A6.37 6.37 0 0 1 6.991.583a6 6 0 0 1 .488.025 6 6 0 0 1-.285.67c-.635 1.244-1.784 2.488-3.229 3.5a4 4 0 0 1-.203.136l-.114.074a9 9 0 0 1-.55-2.99M1.964 3.014a.179.179 0 0 1 .318.092v.004c.092.748.27 1.493.535 2.21a.175.175 0 0 1-.082.217c-.639.342-1.277.606-1.888.791a.18.18 0 0 1-.228-.196 6.4 6.4 0 0 1 1.345-3.118m7.263 7.017c1.167-1.661 2.633-2.887 3.939-3.422v-.003a.18.18 0 0 1 .246.16 6.4 6.4 0 0 1-1.248 4.056.2.2 0 0 1-.154.075 9.1 9.1 0 0 1-2.993-.55q.1-.158.21-.316m-.542 1.15a10 10 0 0 0 2.216.535l.003.004c.16.018.218.217.093.317a6.4 6.4 0 0 1-3.125 1.343.18.18 0 0 1-.196-.228c.185-.612.45-1.25.792-1.888a.174.174 0 0 1 .217-.082M3.313 6.436a10 10 0 0 0 1.377 2.01V8.44c.06.072.06.175-.007.243l-2.401 2.398a.18.18 0 0 1-.268-.01 6.4 6.4 0 0 1-1.43-3.597.184.184 0 0 1 .135-.185 10.8 10.8 0 0 0 2.355-.93.174.174 0 0 1 .239.075m2.254 1.368a.18.18 0 0 1-.264-.007l.004-.003a9.2 9.2 0 0 1-1.23-1.832.177.177 0 0 1 .063-.232q.166-.107.34-.224c1.562-1.09 2.81-2.452 3.51-3.824q.202-.401.335-.788a.177.177 0 0 1 .21-.117c.92.228 1.78.655 2.523 1.265a.18.18 0 0 1 .01.267zm-.014 1.508a10 10 0 0 0 2.009 1.372l-.004.003c.09.047.121.154.075.24-.425.8-.735 1.6-.931 2.358a.18.18 0 0 1-.186.132 6.37 6.37 0 0 1-3.596-1.433.18.18 0 0 1-.01-.267l2.4-2.398a.177.177 0 0 1 .243-.007m6.41-6.361a6.34 6.34 0 0 1 1.264 2.52v.003a.18.18 0 0 1-.118.21c-1.552.535-3.246 1.885-4.616 3.842a5 5 0 0 0-.229.338.177.177 0 0 1-.232.064 9 9 0 0 1-1.83-1.23.18.18 0 0 1-.007-.263l5.501-5.495a.18.18 0 0 1 .268.01"
                        clip-rule="evenodd"></path>
                </svg>
                <span class="bottom-nav-label">Sports</span>
            </router-link>
        </div>
        <div class="bottom-nav-item" :class="{ 'bottom-nav-item--active': isChatOpen }">
            <button type="button" class="bottom-nav-link bottom-nav-link--btn"
                :aria-label="isChatOpen ? 'Close chat' : 'Open chat'" :aria-expanded="isChatOpen" @click="toggleChat">
                <span class="bottom-nav-icon-wrap" aria-hidden="true">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 14 14"
                        class="bottom-nav-icon-svg" style="width: 20px; height: 20px;">
                        <path fill-rule="evenodd"
                            d="M2.875.583A1.375 1.375 0 0 0 1.5 1.958v8.176l-.893 2.68a.459.459 0 0 0 .545.59l3.612-.904h7.277a1.375 1.375 0 0 0 1.375-1.375V1.958A1.375 1.375 0 0 0 12.042.583zm1.26 4.443c0-.318.257-.573.573-.573h5.5a.573.573 0 0 1 0 1.146h-5.5a.573.573 0 0 1-.573-.573m.573 2.46a.573.573 0 1 0 0 1.145h3.667a.573.573 0 0 0 0-1.146z"
                            clip-rule="evenodd"></path>
                    </svg>
                </span>
                <span class="bottom-nav-label">Chat</span>
            </button>
        </div>
    </nav>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'BottomNav',
    computed: {
        ...mapGetters(['generalSidebarMobile', 'generalDesktopChatOpen']),
        isHome() {
            return this.$route.path === '/';
        },
        isCasino() {
            return this.$route.path === '/casino' || this.$route.path === '/slots' || this.$route.path.startsWith('/slots/') || this.$route.path === '/livecasino' || this.$route.path === '/live-casino' || this.$route.path === '/poker';
        },
        isSports() {
            return this.$route.path === '/sports' || this.$route.path.startsWith('/sports/');
        },
        isChatOpen() {
            return this.generalSidebarMobile === 'Chat' || this.generalDesktopChatOpen;
        }
    },
    methods: {
        ...mapActions(['generalSetSidebarMobile', 'generalSetDesktopChatOpen']),
        closeSidebar() {
            this.generalSetSidebarMobile(null);
        },
        toggleChat() {
            this.generalSetSidebarMobile(this.generalSidebarMobile === 'Chat' ? null : 'Chat');
        }
    }
};
</script>

<style scoped>
.bottom-nav {
    display: none;
}

@media only screen and (max-width: 1024px) {
    .bottom-nav {
        display: flex;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 72px;
        justify-content: space-evenly;
        align-items: center;
        gap: 8px;
        background: var(--bg-blue-dark, #1e2238);
        border-top: 1px solid rgba(255, 255, 255, 0.08);
        border-radius: 20px 20px 0 0;
        box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.3);
        z-index: 100002;
        padding: 8px 12px calc(12px + env(safe-area-inset-bottom, 0px));
    }

    .bottom-nav-item {
        flex: 1;
        display: flex;
        align-items: stretch;
        justify-content: center;
        position: relative;
        min-width: 0;
    }

    .bottom-nav-link {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 4px;
        width: 100%;
        min-height: 44px;
        padding: 8px 4px 4px;
        background: transparent;
        border: none;
        cursor: pointer;
        text-decoration: none;
        color: rgba(255, 255, 255, 0.7);
        transition: color 0.2s ease, background 0.2s ease;
        -webkit-tap-highlight-color: transparent;
        border-radius: 12px;
    }

    .bottom-nav-link--btn {
        font: inherit;
    }

    .bottom-nav-link:active {
        background: rgba(255, 255, 255, 0.06);
    }

    .bottom-nav-icon-wrap {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        flex-shrink: 0;
    }

    .bottom-nav-icon {
        width: 24px;
        height: 24px;
        object-fit: contain;
        display: block;
    }

    .bottom-nav-icon-svg {
        width: 24px;
        height: 24px;
        display: block;
        color: currentColor;
    }

    .bottom-nav-label {
        font-size: 11px;
        font-weight: 500;
        letter-spacing: 0.02em;
        text-align: center;
        line-height: 1.2;
    }

    /* Active/selected state: rounded pill background + white icon + white label (no bottom line) */
    .bottom-nav-item--active .bottom-nav-link {
        color: #ffffff;
        background: rgba(255, 255, 255, 0.12);
        border-radius: 12px;
    }

    .bottom-nav-item--active .bottom-nav-link:active {
        background: rgba(255, 255, 255, 0.12);
    }

    .bottom-nav-item--active .bottom-nav-icon {
        filter: brightness(0) invert(1);
    }

    .bottom-nav-item--active .bottom-nav-icon-svg {
        color: #ffffff;
    }

    .bottom-nav-item--active .bottom-nav-label {
        color: #ffffff;
        font-weight: 600;
    }
}
</style>
